
import React, { useState ,useEffect} from 'react';

export default function Head() {
  useEffect(() => {
    const access=JSON.parse(localStorage.getItem("admin"))
    if(access==null)
    {
      window.location.replace("/login");
    }
  }, []);

  return (
    <>
     <nav className="navbar">
        <a href="#" className="sidebar-toggler">
          <i data-feather="menu" />
        </a>
        <div className="navbar-content">
          
            <div className="input-group mt-3">
               <h3> Welcome to Royal Travels and Tours </h3>               
            </div>
          
          
        </div>
      </nav>
    </>
  )
}
